import { UserScope } from '@logto/js';

const logtoClientErrorCodes = Object.freeze({
    'sign_in_session.invalid': 'Invalid sign-in session.',
    'sign_in_session.not_found': 'Sign-in session not found.',
    not_authenticated: 'Not authenticated.',
    fetch_user_info_failed: 'Unable to fetch user info. The access token may be invalid.',
    user_cancelled: 'The user cancelled the action.',
    missing_scope_organizations: `The \`${UserScope.Organizations}\` scope is required`,
});
class LogtoClientError extends Error {
    constructor(code, data) {
        super(logtoClientErrorCodes[code]);
        this.name = 'LogtoClientError';
        this.code = code;
        this.data = data;
    }
}

export { LogtoClientError };
